import * as React from "react";

import {
  CrisisBanner,
  PageManifestCrisisBanner,
} from "@origin-digital/crisis-banner";
import { PrefetchedContent } from "../../components/prefetch";
import Breadcrumbs, {
  getBreadcrumbsContent,
} from "../../components/Breadcrumbs";
import RootWrapper from "../../components/RootWrapper";
import { SuppressAndroidInstallPrompt } from "../../components/SuppressAndroidInstallPrompt";
import { SkipLink } from "../../components/SkipLink";
import { CMSAppContent } from "./AppContent";

//TODO: Type this exactly to match what tal-core passes on.
export interface AppProps {
  children?: React.ReactNode;
  showNativeAppAd?: boolean;
  setupFonts?: boolean;
  showHeader?: boolean | "unauth" | "scoped";
  prefetchContent?: Record<string, PrefetchedContent>;
  crisisBanner?: PageManifestCrisisBanner;
  storyMode?: boolean;
}

export const CMSApp = ({
  showNativeAppAd = true,
  showHeader = true,
  setupFonts = false,
  prefetchContent = {},
  crisisBanner = "top",
  storyMode = false,
}: AppProps) => {
  const breadcrumbsContent = getBreadcrumbsContent(prefetchContent);

  const HeaderContent = (
    <div>
      {crisisBanner === "top" && <CrisisBanner position={crisisBanner} />}
      {!showNativeAppAd && <SuppressAndroidInstallPrompt />}
      <SkipLink target="#page" />
      <CMSAppContent
        showHeader={showHeader}
        title=""
        actionBar={{ hidden: true }}
        crisisBanner={crisisBanner}
      />
      {crisisBanner === "float" && <CrisisBanner position={crisisBanner} />}
      {breadcrumbsContent && <Breadcrumbs data={breadcrumbsContent} />}
    </div>
  );

  return storyMode ? (
    HeaderContent
  ) : (
    <RootWrapper setupFonts={setupFonts}>{HeaderContent}</RootWrapper>
  );
};
